module.exports = __webpack_public_path__ + "img/Group 3014.a331a158.svg";